import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
 batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';

import Text from '../../Text/Text';
import Checkbox from '../../Checkbox/Checkbox';
import CarNoteModal from './CarNoteModal';
import { setCompatibilityList } from '../../../actions/vehicleCompatibility/vehicleCompatibilityList';

const CarData = ({
 data, onSelect, selectAll, setCarNote
}) => {
  const dispatch = useDispatch();
  const [carNoteModal, setCarNoteModal] = useState(false);
  const [noteCarId, setNoteCarId] = useState(0);
  const [currentNote, setCurrentNote] = useState('');
  const {
    vehicleCompatibilityList
  } = useSelector((state) => ({
    vehicleCompatibilityList: state?.vehicleCompatibilityList.data

  }), shallowEqual);
  const onNoteSave = (noteText) => {
    const newCatList = setCarNote(vehicleCompatibilityList, noteCarId, noteText);
    dispatch(setCompatibilityList(newCatList));
    setCarNoteModal(false);
  };

  return (
    <div>
      <div>
        <span
          className="globalLink"
          onClick={selectAll}
          role="presentation"
        >
          Reverse
        </span>
        {
          Object.keys(data)
            ?.map((trim) => Object.keys(data[trim])
              ?.map((engine) => {
                const { selected, car_id: carId, car_note: carNote } = data[trim][engine];
                return (
                  <div
                    key={carId}
                    className="flex flex-row justify-between py-[12px] border-b border-[#EFF2F5] dark:border-[#1b263b]"
                  >
                    <div className="flex flex-row items-center">
                      <Checkbox
                        name={`car_id_${carId}`}
                        isActive={selected}
                        onChange={() => {
                          onSelect({
                            trim,
                            engine,
                            info: {
                              car_id: carId,
                              selected: !selected,
                              car_note: carNote
                            }
                          });
                        }}
                        text={<Text text={trim} textStyle="text-[13px]" />}
                      />
                    </div>
                    <Text text={engine} textStyle="text-[13px]" />
                    <div
                      role="presentation"
                      onClick={() => {
                        batch(() => {
                          setNoteCarId(carId);
                          setCurrentNote(carNote);
                          setCarNoteModal(true);
                        });
                      }}
                      className="globalLink"
                    >
                      {carNote || 'Add note'}
                    </div>
                  </div>
                );
              }))
        }
      </div>
      <CarNoteModal
        visible={carNoteModal}
        toggleVisible={() => setCarNoteModal(false)}
        onSave={onNoteSave}
        note={currentNote}
      />
    </div>
  );
};

CarData.propTypes = {
  data: PropTypes.shape({}),
  onSelect: PropTypes.func,
  selectAll: PropTypes.func,
  setCarNote: PropTypes.func,
};

CarData.defaultProps = {
  data: {},
  onSelect: () => {},
  selectAll: () => {},
  setCarNote: () => {},
};

export default CarData;
